<template>
  <div class="body-t">
    <van-sticky>
      <van-nav-bar
          left-arrow
          left-text="返回"
          title="企业列表"
          @click-left="onClickLeft"
      />
      <div class="search-box">
        <van-field v-model="keyword" left-icon="search" placeholder="请输入搜索关键词" @keydown.enter="init(true)"/>
      </div>
    </van-sticky>
    <div class="count-bar">
      查询意向企业 <span>{{ this.total }}</span> 家
    </div>
    <div class="data-list">
      <van-empty v-show="list.length < 1 && !load" description="未查询到记录哦~" image="search"
                 style="color: goldenrod;border-radius: 3px"/>
      <van-list
          v-model="load"
          :finished="finished"
          finished-text="已经到底了~"
          @load="init"
      >
        <van-collapse v-model="activeName" accordion>
          <van-collapse-item v-for="(item,index) in list" :key="item.id" :name="index" class="desc-elem">
            <template #title>
              <div><span class="sort">{{ index + 1 }}.</span> {{ item.company_name }}</div>
              <div class='time'>
                申请时间： {{ item.create_time }}
              </div>
            </template>
            <div class="box-desc van-clearfix">
              <div>
                <router-link :to="{name:'Hall',query:{id:item.CompanyId}}">
                  <van-image :src="item.logo" class="company-logo" fit="contain" lazy-load
                  >
                    <template v-slot:error>无企业LOGO</template>
                  </van-image>
                </router-link>
              </div>
              <div>
                <dl class="desc-dl">
                  <dd>
                    <span style="display: block">原企业:</span>
                    {{ item.CompanyName }}
                  </dd>
                  <dd>
                    <span>联系姓名:</span>
                    {{ item.real_name }}
                  </dd>
                  <dd>
                    <span>手机号码:</span>
                    {{ item.phone }}
                  </dd>

                </dl>
              </div>
            </div>
            <div class="go-to">
              <router-link :to="{name:'Hall',query:{id:item.CompanyId}}">前往 {{ item.CompanyName }} 展厅
                <van-icon name="arrow"/>
              </router-link>
            </div>
          </van-collapse-item>
        </van-collapse>
      </van-list>

    </div>
  </div>
</template>

<script>


export default {
  name: "Hall",
  metaInfo: {
    title: '意向企业列表 @优采云大数据服务平台',
    htmlAttrs: {
      lang: 'zh-CN',
      keyword:'优采云，大数据，云服务，报告',
      amp: true
    }
  },
  data() {
    return {
      load: false,
      finished: false,
      list: [],
      keyword: '',
      activeName: 0,
      page: 1
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    init(reset_page = false) {
      //某些情况下重置
      if (reset_page) {
        this.page = 1
        this.activeName = 0
        this.list = []
      }
      this.load = true
      this.$axios.post(this.$apiconfg.connect, {
        keyword: this.keyword,
        page: this.page
      }).then(({data}) => {
        if (data.code === 1) {
          //翻页
          this.page += 1
          //没有下一页了
          if (data.data.hasMore) {
            this.finished = false
          } else {
            this.finished = true
          }
          for (let i = 0; i < data.data.list.length; i++) {
            this.list.push(data.data.list[i])
          }

          this.total = data.data.total
        }
        this.load = false
      }).catch(() => {
        this.load = false
        this.finished = true
      })
    }

  }
}
</script>

<style scoped>
.pd-10 {
  padding: 10px;
}

.data-list {
  padding: 10px;
}

.body-t {
  background: #eff3f6;
  padding-bottom: 60px;
  min-height: calc(100vh);
}

.time {
  font-size: 12px;
  color: #646566;
}

.tips-tie {
  color: orange;
  font-size: 12px;
}

.box-desc {
  background: rgb(250, 250, 250);
  padding: 10px;
}

.desc-elem /deep/ .van-collapse-item__content {
  padding: 0 15px;
}

.box-desc > div {
  float: left;
}

.box-desc > div:first-child {
  width: 100px;
}

.box-desc > div:nth-child(2) {
  width: calc(100% - 100px);
}

.company-logo {
  width: 100px;
  height: 60px;
  background: #FFFFFF;
  border-radius: 3px;
  box-sizing: border-box;
  padding: 5px;
}

.desc-dl {
  margin-left: 10px;
  font-size: 12px;
}

.desc-dl > dd {
  margin: 0;
  margin-bottom: 8px;
  color: #646566;
}

.desc-dl > dd > span {
  display: inline-block;
  color: #969799;
  letter-spacing: .2px;
}

.go-to {
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
  padding-bottom: 10px;

}

.go-to a {
  color: orangered;
}

.count-bar {
  padding: 0 10px;
  color: #404040;
  font-size: 12px;
  margin-top: 10px;
  text-align: right;
  letter-spacing: .2px;
}

.count-bar > span {
  color: #F62A3A;
}

.sort {
  color: orange;
}
</style>